import { render, staticRenderFns } from "./declaracaoBensView.vue?vue&type=template&id=6bae5e14&scoped=true&"
import script from "./declaracaoBensView.vue?vue&type=script&lang=js&"
export * from "./declaracaoBensView.vue?vue&type=script&lang=js&"
import style0 from "./declaracaoBensView.vue?vue&type=style&index=0&id=6bae5e14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bae5e14",
  null
  
)

export default component.exports